/**
 * Build a thread creation payload while preserving the canonical slug.
 * @param {string | null | undefined} slug
 * @returns {{ figure_slug: string | null }}
 */
export const buildThreadCreatePayload = (slug) => {
  if (typeof slug !== 'string') return { figure_slug: null }
  const trimmed = slug.trim()
  return { figure_slug: trimmed.length ? trimmed : null }
}
